export default __webpack_public_path__ + "static/media/avatar_default.c85df9ef.png";